import Vue from 'vue';
import store from './../../store';
import campaignTypeTransformer from './../../transformers/campaignType';

const success = ({ data }, resolve) => {
  const campaignTypes = campaignTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchCampaignTypes', campaignTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display campaign types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('campaign_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/campaignType/all.js